import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { adminGetAllFaculty, adminDeleteFaculty, adminGetAllFacultys } from '../../../redux/action/adminAction';
import AdminHomeHelper from '../../../Components/AdminHomeHelper';
import classnames from 'classnames';
import Loading from '../../../Components/Loading';

const AdminGetAllFaculty = () => {
    const store = useSelector((store) => store);
    const dispatch = useDispatch();
    const [department, setDepartment] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [error, setError] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [searchError, setSearchError] = useState(null);
    const history = useHistory();
  
    const formHandler = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setSearchError(null);
      try {
        await dispatch(adminGetAllFaculty({ department, searchQuery }));
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setSearchError('Error while searching. Please try again later.');
      }
    };
  
    useEffect(() => {
      dispatch(adminGetAllFacultys({}));
    }, []);

  useEffect(() => {
    const allFacultyLength = store.admin.allFaculty.length;
    
    if (allFacultyLength !== 0) {
      setIsLoading(false);
    }
  
    return () => {
      setIsLoading(false);
    };
  }, [store.admin.allFaculty.length]);
  

  const handleDeleteFaculty = (facultyId) => {
    console.log("Deleting Faculty with ID: ", facultyId);

    const shouldDelete = window.confirm("Are you sure you want to delete this Faculty?");

    if (shouldDelete) {
      dispatch(adminDeleteFaculty(facultyId));

      alert("Faculty deleted successfully!");

      window.location.reload();
    }
  };

  const filteredFaculty = store.admin.allFaculty.filter((faculty) => {
    const searchFields = Object.values(faculty).map(value => value?.toString() || '');
    const normalizedQuery = searchQuery.toLowerCase().trim();
  
    return searchFields.some((field) => field.toLowerCase().includes(normalizedQuery));
  });
  
  const isDataAvailable = store.admin.allFaculty && store.admin.allFaculty.length > 0;

  return (
    <div>
      {store.admin.isAuthenticated ? (
      <div className="container-fluid p-0">
          <div className="d-flex">
              <div className="print-helper">
                <AdminHomeHelper />
              </div>
              <div className="mx-1 w-100 ">
                <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                  <h3> <img src="/logo192.png" width={'50px'} alt="" /> OUR FACULTIES</h3>
                  <button onClick={()=> window.print()} type="button" className=" print-helper btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                </div>
              <div className="col d-flex align-items-center justify-content-between ">
                <form form-inline className='d-flex align-items-center justify-content-start ' noValidate onSubmit={formHandler}>
                  <div className="form-group mx-2 print-helper">
                    <label htmlFor="departmentId">Department</label>
                    <select onChange={(e) => setDepartment(e.target.value)} className={classnames("form-control", { 'is-invalid': error.department })} id="departmentId">
                      <option>Select</option>
                      <option value="ECE">ECE</option>
                      <option value="CSE">CSE</option>
                      <option value="EEE">EEE</option>
                      <option value="AIDS">AIDS</option>
                      <option value="MECH">MECH</option>
                      <option value="CIVIL">CIVIL</option>
                                                <option value="BIO">BIO</option>
                                                <option value="AGRI">AGRI</option>
                                                <option value="MBA">MBA</option>
                                                <option value="MCA">MCA</option>
                    </select>
                    {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                  </div>
                  <div className="form-group mx-2 print-helper">
                    <label htmlFor="searchQuery">Search</label>
                    <input
                      type="text"
                      className="form-control"
                      id="searchQuery"
                      placeholder="Search by name, ID, department, etc."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                  <div className="mt-3">
                    {!isLoading && <button type="submit" className="btn btn-info btn-block print-helper"><img src="/image/search.svg" className='mb-1' alt="" /> Search</button>}
                    {isLoading && (
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    )}
                  </div>
                </form>
                <button className='btn btn-success print-helper '> <Link to="/admin/addFaculty" className='text-light'> <img src="/image/add.svg" alt="" /> Faculty Registration</Link></button>
              </div>
              {isDataAvailable ? (
              <div className="col">

                {filteredFaculty.length !== 0 && (
                  <table className="mt-3 table table-responsive table table-bordered table-striped-columns">
                    <thead>
                      <tr className='bg-secondary text-light'>
                        <th scope="col" width="5%">S.No</th>
                        <th scope="col" width="10%">Photo</th>
                        <th scope="col" width="10%">Faculty Id</th>
                        <th scope="col" width="10%">Name</th>
                        <th scope="col" width="10%">Department</th>
                        <th scope="col" width="10%">DOJ</th>
                        <th scope="col" width="10%">Designation</th>
                        <th scope="col" width="20%" className="print-helper">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredFaculty.map((res, index) => (
                        <tr key={index}>
                          <th scope="row">{index + 1}</th>
                          <td><img src={res.avatar} width={'50px'} style={{ borderRadius: "50%", height: '50px', border: '2px solid #3D5356' }} alt="" /></td>
                          <td>{res.registrationNumber}</td>
                          <td>{res.name}</td>
                          <td>{res.department}</td>
                          <td>{res.joiningYear}</td>
                          <td>{res.designation}</td>
                          <td className="print-helper" style={{ whiteSpace: 'nowrap' }}>
                            <small className='bg-info text-light p-1 btn m-1'>
                              <Link to={`/admin/adminFacultyView/${res._id}`} className='text-light'><img src="/image/view.svg" alt="" /> View</Link>
                            </small>
                            <small className='bg-success text-light p-1 btn m-1'>
                            <Link to={`/admin/AdminFacultyUpdate/${res._id}`} className='text-light'><img src="/image/edit.svg" alt="" /> Edit</Link>
                            </small>
                            <small className='bg-danger text-light p-1 btn m-1' onClick={() => handleDeleteFaculty(res._id)}>
                              <img src="/image/delete.svg" alt="" /> Del
                            </small>
                          </td>                         
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

              </div>
               ) : (
                <Loading />
                )}
            </div>
          </div>
        </div>
      ) : (history.push('/'))}
    </div>
  );
}

export default AdminGetAllFaculty